import { render, staticRenderFns } from "./DedicatedStatementsReportUser.vue?vue&type=template&id=739024ca"
import script from "./DedicatedStatementsReportUser.vue?vue&type=script&lang=js"
export * from "./DedicatedStatementsReportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports